import { ImagePath } from "../../assets/ImagePath";
import { FRONTM_TITLE, INTELSAT_TITLE, LEDGID_TITLE, ONSHIP_TITLE, VIKAND_TITLE } from "../constants";
import {
    ONSHIP_FAViCON, PAL_CARE_FAViCON, PAL_CARE_TITLE, SEA_DANCE_FAViCON, SEA_DANCE_TITLE, SEMEDIX_TITLE, STATION_SATCOM_FAViCON,
    STATION_SATCOM_TITLE
} from "../constants/appHeadConfig";

const getCurrentHostname = () => {
    try {
        return new URL(window.location.href).hostname;
    } catch (error) {
        console.error("Invalid domain URL:", error);
        return "";
    }
};

const getDomainStatus = (targetDomain) => {
    const hostname = getCurrentHostname();
    return hostname === targetDomain;
};

//All Domains ====> 
// DEV localhost
export const PAL_CARE_DEV2 = "dev2.frontm.com"; 
export const DEV1 = "dev1.frontm.com"; 
export const LEDGID_DEV =  'ledgiddev.frontm.ai'


// STAGE
export const ONSHIP_STAGE_URL = 'stage.frontm.com';
export const VIKAND_STAGE_URL = 'stage-vikand.onship.app';
export const INTELSAT_STAGE_URL = "intelsatstage.frontm.com"  
export const STATION_ONE_STAGE_URL = "stage.stationone.io"
export const SEAMEDEX_STAGE = 'seamedixstage.onship.app';
export const STAGE_ONSHIP_URL = 'stage.onship.app';
export const LEDGID_STAGE = 'ledgidstage.frontm.ai';

//PROD
export const INFOTAIN = 'infotain.frontm.ai';
export const ONSHIP_PROD_URL = 'onship.app';
export const STATION_ONE_PROD_URL = "stationone.io"
export const VIKAND_PROD_URL = 'vikand.frontm.com';
export const ONECARE_PROD_URL = 'onecare.frontm.com';
export const SEAMEDEX_PRODUCTION = 'app.seamedix.com';
export const PIVOTEL_PROD_URL = 'app.pulsarcommunity.com';
export const INTELSAT_PROD_URL = "intelsat.frontm.com";
export const SEA_DANCE_DOMAIN = "app.sea-dance.com";
export const SEA_DANCE_FRONTM_DOMAIN = "seadance.frontm.ai";
export const FRONTM_AI_DOMAIN = "frontm.ai";
export const INFORM_FRONTM = "inform.frontm.com"
export const INFORM_SEA_DANCE = "inform.sea-dance.com"
export const VIKAND_STAGE_2_URL = 'stage2.frontm.com';
export const VIKAND_CONNECT = 'vikandconnect.com';

//get Domain Status
export const isPalCareDev2Domain = [PAL_CARE_DEV2].some(getDomainStatus);
export const isSeamedixDomain = [SEAMEDEX_STAGE, SEAMEDEX_PRODUCTION].some(getDomainStatus);
export const isSeaDanceDomain = [SEA_DANCE_DOMAIN, SEA_DANCE_FRONTM_DOMAIN, INFORM_FRONTM, INFORM_SEA_DANCE].some(getDomainStatus);
export const isOnshipDomain = [ONSHIP_PROD_URL, FRONTM_AI_DOMAIN, DEV1, ONSHIP_STAGE_URL,STAGE_ONSHIP_URL].some(getDomainStatus);
export const isIntelsatDomain = [INTELSAT_PROD_URL,INTELSAT_STAGE_URL].some(getDomainStatus);
export const isVikandDomain = [VIKAND_PROD_URL, VIKAND_STAGE_URL,VIKAND_STAGE_2_URL, VIKAND_CONNECT].some(getDomainStatus);
export const isFrontmAiDomain = [FRONTM_AI_DOMAIN].some(getDomainStatus);
export const isStageOnshipDomain = [STAGE_ONSHIP_URL].some(getDomainStatus);
export const isLedgidDomain = [LEDGID_DEV,LEDGID_STAGE].some(getDomainStatus);


export const getDomainConfig = () => {
    const domainGroups = [
        {
            name: "Ledgid",
            domains: [LEDGID_DEV, LEDGID_STAGE],
            logo: ImagePath.logoOnship,
            banner: ImagePath.palCareLoginBGM,
            title: LEDGID_TITLE,
            favicon: ONSHIP_FAViCON,
        },
        {
            name: "Intelsat",
            domains: [INTELSAT_PROD_URL, INTELSAT_STAGE_URL],
            logo: ImagePath.intelsatLogin,
            banner: ImagePath.intelsatLoginBanner,
            title: INTELSAT_TITLE,
            favicon: ONSHIP_FAViCON,
        },
        {
            name: "PalCareDev2",
            domains: [PAL_CARE_DEV2],
            logo: ImagePath.mariAppLogo,
            banner: ImagePath.palCareLoginBGM,
            title: PAL_CARE_TITLE,
            favicon: PAL_CARE_FAViCON,
        },
        {
            name: "Seamedix",
            domains: [SEAMEDEX_STAGE, SEAMEDEX_PRODUCTION],
            logo: ImagePath.mariAppLogo,
            banner: ImagePath.seamedixLoginBanner,
            title: SEMEDIX_TITLE,
            favicon: PAL_CARE_FAViCON,
        },
        {
            name: "Vikand",
            domains: [VIKAND_PROD_URL, VIKAND_STAGE_URL,VIKAND_STAGE_2_URL, VIKAND_CONNECT],
            logo: ImagePath.VikandLogo,
            banner: ImagePath.vikandLoginBanner,
            title: VIKAND_TITLE,
            favicon: ONSHIP_FAViCON,
        },
        {
            name: "SeaDance",
            domains: [SEA_DANCE_DOMAIN, SEA_DANCE_FRONTM_DOMAIN, INFORM_FRONTM, INFORM_SEA_DANCE],
            logo: ImagePath.smalllogo,
            banner: ImagePath.palCareLoginBGM,
            title: SEA_DANCE_TITLE,
            favicon: SEA_DANCE_FAViCON,
        },
        {
            name: "Onship",
            domains: [ONSHIP_PROD_URL, DEV1, ONSHIP_STAGE_URL, STAGE_ONSHIP_URL],
            logo: ImagePath.logoOnship,
            banner: ImagePath.palCareLoginBGM,
            title: ONSHIP_TITLE,
            favicon: ONSHIP_FAViCON,
        },
         {
            name: "Frontm",
            domains: [ FRONTM_AI_DOMAIN],
            logo: ImagePath.frontmLogo,
            banner: ImagePath.frontmBanner,
            title: FRONTM_TITLE,
            favicon: ONSHIP_FAViCON,
        },
    ];

    // Check which domain matches
    for (const group of domainGroups) {
        if (group.domains.some(getDomainStatus)) {
            return group;
        }
    }

    // Default config
    return {
        name: "StationSatcom",
        logo: ImagePath.StationSatcomNewLogo,
        banner: ImagePath.newStationSatcomBGM,
        title: STATION_SATCOM_TITLE,
        favicon: STATION_SATCOM_FAViCON,
    };
};
